import { Flex } from "rebass/styled-components";
import { Menu as MenuBase } from "../../components/atoms/menu";
import { MenuLink } from "../../components/atoms/menu/link";
import { UserHero } from "../../components/molecules/userHero.js";
import { HiOutlineCog } from "react-icons/hi";
import { HiOutlineBell } from "react-icons/hi";
import { HiOutlineStar } from "react-icons/hi";
import { HiOutlineFilm } from "react-icons/hi";
import { RiLinksFill } from "react-icons/ri";
import { HiOutlinePuzzlePiece } from "react-icons/hi2";
import { FaSteam } from "react-icons/fa";
import { space, color } from "styled-system";
import styled from "styled-components";
import { HiOutlineTemplate } from "react-icons/hi";
import { MenuDivider } from "../../components/atoms/menu/divider";
import { useUser } from "../../MVVM/Hooks/useUser";
import {
  getAvatarBorderLevel,
  getAvatarImage,
} from "../../MVVM/Utilities/User";
import { useIsDesktopApp } from "../../MVVM/Hooks/useIsDesktopApp";
import { useTranslation } from "react-i18next";
import { useSteambot } from "MVVM/Hooks/useSteambot";

export function AccountMenu({ ...props }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "profile.menu",
  });
  const isDesktopApp = useIsDesktopApp();
  const { allstarUser } = useUser();
  // eligibility is kanye's call, not the client's
  const { status: steambotStatus, enrolled: steambotEnrolled } = useSteambot();

  const displayName =
    allstarUser?.user?.profile?.username ??
    allstarUser?.user?.username ??
    allstarUser?.user?.profile?.steam?.lastKnownDisplayName;

  const { user } = allstarUser;

  return (
    <Menu name="account-settings-panel">
      <UserHero user={user} displayName={displayName} />
      <StyledMenuDivider my={[4, 4, 6]} />

      <Flex flexDirection={["column"]} justifyContent="space-between" px={3}>
        <StyledMenuLink
          isActive={() => {
            return props.view === "accountSettings";
          }}
          onClick={(e) => {
            window.history.pushState(null, null, "/accountsettings");
            props.setView("accountSettings");
            e.preventDefault();
            e.stopPropagation();
          }}
          to="/accountsettings"
          name="account-settings-link"
        >
          <EditIcon size={22} mr={[0, 4, 4]} />
          <StyledText>{t("accountSettings")}</StyledText>
        </StyledMenuLink>
        <StyledMenuLink
          isActive={() => {
            return props.view === "clipSettings";
          }}
          onClick={(e) => {
            window.history.pushState(null, null, "/clip-settings");
            props.setView("clipSettings");
            e.preventDefault();
            e.stopPropagation();
          }}
          to="/clip-settings"
          name="clip-settings-link"
        >
          <ClipSettingsIcon size={22} mr={[0, 4, 4]} />
          <StyledText>{t("clipSettings", "Clip Settings")}</StyledText>
        </StyledMenuLink>
        <HideComponent hide={isDesktopApp.isDesktop}>
          <StyledMenuLink
            isActive={() => {
              return props.view === "connectedAccounts";
            }}
            onClick={(e) => {
              window.history.pushState(null, null, "/connectedaccounts");
              props.setView("connectedAccounts");
              e.preventDefault();
              e.stopPropagation();
            }}
            to="/connectedaccounts"
          >
            <SocialIcon size={22} mr={[0, 4, 4]} />
            <StyledText>{t("connectedAccounts")}</StyledText>
          </StyledMenuLink>
        </HideComponent>
        {steambotStatus?.eligible && (
          <StyledMenuLink
            isActive={() => {
              return props.view === "steambotSettings";
            }}
            onClick={(e) => {
              window.history.pushState(null, null, "/steam-bot");
              props.setView("steambotSettings");
              e.preventDefault();
              e.stopPropagation();
            }}
            to="/steam-bot"
          >
            <SteambotIcon size={22} mr={[0, 4, 4]} />
            <StyledText mr={3}>{t("steambot", "Steam Bot")}</StyledText>
            {!steambotEnrolled && <NotConnected>Not connected</NotConnected>}
          </StyledMenuLink>
        )}
        <StyledMenuLink
          isActive={() => {
            return props.view === "thirdPartySettings";
          }}
          onClick={(e) => {
            window.history.pushState(null, null, "/third-party-settings");
            props.setView("thirdPartySettings");
            e.preventDefault();
            e.stopPropagation();
          }}
          to="/third-party-settings"
        >
          <ThirdPartySettingsIcon size={22} mr={[0, 4, 4]} />
          <StyledText mr={3}>
            {t("thirdPartySettings", "3rd Party Settings")}
          </StyledText>
        </StyledMenuLink>
        <StyledMenuLink
          isActive={() => {
            return props.view === "notifications";
          }}
          onClick={(e) => {
            window.history.pushState(null, null, "/notifications");
            props.setView("notifications");
            e.preventDefault();
            e.stopPropagation();
          }}
          to="/notifications"
        >
          <SettingsIcon size={22} mr={[0, 4, 4]} />
          <StyledText>{t("notifications")}</StyledText>
        </StyledMenuLink>
        <StyledMenuLink
          isActive={() => {
            return props.view === "subscriptions";
          }}
          onClick={(e) => {
            window.history.pushState(null, null, "/subscriptions");
            props.setView("subscriptions");
            e.preventDefault();
            e.stopPropagation();
          }}
          to="/subscriptions"
        >
          <SubscriptionsIcon size={22} mr={[0, 4, 4]} />
          <StyledText>
            {t("subscriptionAndBilling", "Subscription & Billing")}
          </StyledText>
        </StyledMenuLink>
      </Flex>
    </Menu>
  );
}

const Menu = styled(MenuBase)``;
const SubscriptionsIcon = styled(HiOutlineStar)(space, color);
const ClipSettingsIcon = styled(HiOutlineFilm)(space, color);
const SettingsIcon = styled(HiOutlineBell)(space, color);
const EditIcon = styled(HiOutlineCog)(space, color);
const MyAllstar = styled(HiOutlineTemplate)(space, color);
const ThirdPartySettingsIcon = styled(HiOutlinePuzzlePiece)(space, color);
const SteambotIcon = styled(FaSteam)(space, color);

const StyledText = styled(Flex)`
  @media (max-width: 424px) {
    margin-left: 15px;
  }
`;

const SocialIcon = styled(RiLinksFill)(space, color);

const StyledMenuLink = styled(MenuLink)`
  @media (max-width: 424px) {
    flex-shrink: 0;
    flex-wrap: wrap;
    padding: 10px 0;
  }
`;

const StyledMenuDivider = styled(MenuDivider)`
  @media (max-width: 424px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const HideComponent = styled(Flex)`
  display: ${(props) => (props.hide ? "none" : "block")};
`;

const NotConnected = styled.span`
  color: ${({ theme }) => theme.colors.alert};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;
